import { Permission } from '@traton/devportal-rbac-common-lib';

export const announcementReadPermission: Permission = {
  name: 'announcement.read',
  type: 'basic',
  attributes: { action: 'read' },
};

export const announcementCreatePermission: Permission = {
  name: 'announcement.create',
  type: 'basic',
  attributes: { action: 'create' },
};

export const announcementUpdatePermission: Permission = {
  name: 'announcement.update',
  type: 'basic',
  attributes: { action: 'update' },
};

export const announcementDeletePermission: Permission = {
  name: 'announcement.delete',
  type: 'basic',
  attributes: { action: 'delete' },
};

export const announcementPermissions = [
  announcementReadPermission,
  announcementCreatePermission,
  announcementUpdatePermission,
  announcementDeletePermission,
];
